// Estados en los que el backend genera el recibo PDF y acepta evidencia.
const STATUSES_WITH_RECEIPT = ["authorized", "delivered"];

/**
 * Botones de recibo y evidencia de un renglón de Salidas de Retenciones.
 * Aplica igual a todos los tipos (ADVANCE, CLOSE, OTHER); los cierres nacen
 * en `delivered` sin evidencia, por eso no se puede amarrar la carga a
 * `authorized`.
 *
 * - pdf: en `authorized` o `delivered`; no se quita al subir la evidencia.
 * - upload: en `authorized` o `delivered`, sin evidencia y con permiso.
 * - evidence: solo con evidencia; sin ella el backend responde error.
 * - deliver: en `authorized` una vez que ya hay evidencia.
 *
 * Los botones de `created` y el permiso de entrega se resuelven en la celda.
 */
export const getRetentionRowActions = ({ status, urlEvidence } = {}, { canUploadEvidence = false } = {}) => {
  const hasReceipt = STATUSES_WITH_RECEIPT.includes(status);
  const hasEvidence = Boolean(urlEvidence);

  return {
    pdf: hasReceipt,
    upload: hasReceipt && !hasEvidence && canUploadEvidence,
    evidence: hasReceipt && hasEvidence,
    deliver: status === "authorized" && hasEvidence,
  };
};
